import Ref from "csi/heading/Ref";
import declare from "dojo/_base/declare";
import UOMTypeForBOMQtyFromMaterialRendererMixin from "./UOMTypeForBOMQtyFromMaterialRendererMixin";

const UOMTypeForBOMQtyFromMaterialRefRenderer = declare(
	[Ref, UOMTypeForBOMQtyFromMaterialRendererMixin],
	{},
);

export = UOMTypeForBOMQtyFromMaterialRefRenderer;
